import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

import { ActivitiesCartDisplayType } from 'src/app/interfaces';
import { IEventSettings, IGetActivitiesCartResponse } from 'src/app/shared/interfaces';
import { ActivityCartDisplayFilterItemId } from './interfaces';
import { ICartActivityItem } from './list/interfaces';

@Component({
    selector: 'aza-rws-activities-cart',
    templateUrl: 'activities-cart.component.html',
    standalone: false
})
export class ActivitiesCartComponent implements OnInit {
    @Input() eventSettings: IEventSettings;
    @Input() showActivitiesCart: Subject<IGetActivitiesCartResponse>;
    @Input() activitiesCartDisplayType: ActivitiesCartDisplayType;
    @Input() locked = false;
    @Input() showAddToCalendar = false;
    @Input() hideAvailablePlacesLeft = false;

    @Output() activitiesChanged = new EventEmitter<ICartActivityItem[]>();

    activitiesCartFilterSubject = new ReplaySubject<ActivityCartDisplayFilterItemId>(1);
    selectedDisplayFilterItemId = ActivityCartDisplayFilterItemId.all;
    searchTextChanged = new Subject<string>();
    quickSearchText = '';

    ngOnInit(): void {
        this.activitiesCartFilterSubject.next(this.selectedDisplayFilterItemId);
    }

    onActivitiesChanged(cartActivityItems: ICartActivityItem[]): void {
        this.activitiesChanged.next(cartActivityItems);
    }

    async onSearchTextChanged(): Promise<void> {
        this.searchTextChanged.next(this.quickSearchText);
    }

    onDisplayFilterChanged(ev: Event): void {
        const el = ev.target as HTMLSelectElement;
        this.selectedDisplayFilterItemId = el.value as ActivityCartDisplayFilterItemId;
        this.activitiesCartFilterSubject.next(this.selectedDisplayFilterItemId);
    }
}
